import { colorPalette } from 'stylesheet';

import { ButtonDisplayStyle } from './Button.types';

export const getFontWeight = ($displayStyle?: ButtonDisplayStyle) => {
  if (!$displayStyle) return 'normal';
  switch ($displayStyle) {
    case 'text':
      return 'bold';
    default:
      return 'normal';
  }
};

export const getColor = ($displayStyle?: ButtonDisplayStyle) => {
  if (!$displayStyle) return colorPalette.greyMain;
  switch ($displayStyle) {
    case 'filledOrange':
    case 'filledRed':
    case 'filledBlue':
    case 'primary':
      return colorPalette.white;
    case 'filledAccent':
      return colorPalette.eerie_black;
    case 'unfilledGrey':
    case 'unfilledGreyWithoutBorder':
    case 'unfilledOrange':
    case 'unfilledRed':
    case 'unfilledBlue':
      return colorPalette.greyMain;
    case 'underlineText':
    case 'text':
      return colorPalette.secondary_600;
  }
};
export const getBorder = ($displayStyle?: ButtonDisplayStyle) => {
  if (!$displayStyle) return 'unset';
  switch ($displayStyle) {
    case 'filledOrange':
    case 'unfilledOrange':
      return `solid 1px ${colorPalette.secondary_600}`;
    case 'unfilledGrey':
      return `solid 1px ${colorPalette.greyMain}`;
    case 'filledRed':
    case 'unfilledRed':
      return `solid 1px ${colorPalette.status_error}`;
    case 'filledBlue':
    case 'unfilledBlue':
      return `solid 1px ${colorPalette.blue_500}`;
    case 'primary':
      return `solid 1px ${colorPalette.primary}`;
    default:
      return 'unset';
  }
};
export const getBackground = ($displayStyle?: ButtonDisplayStyle) => {
  if (!$displayStyle) return 'unset';
  switch ($displayStyle) {
    case 'filledOrange':
      return colorPalette.secondary_600;
    case 'filledRed':
      return colorPalette.status_error;
    case 'filledBlue':
      return colorPalette.blue_500;
    case 'filledAccent':
      return colorPalette.yellow;
    case 'primary':
      return colorPalette.primary;
    case 'unfilledGrey':
    case 'unfilledOrange':
    case 'unfilledRed':
    case 'unfilledBlue':
      return colorPalette.white;
    default:
      return 'unset';
  }
};
export const getHoverBorder = ($displayStyle?: ButtonDisplayStyle) => {
  if (!$displayStyle) return 'unset';
  switch ($displayStyle) {
    case 'filledOrange':
      return `solid 1px ${colorPalette.secondary_300}`;
    case 'primary':
      return `solid 1px ${colorPalette.primary}`;
    case 'filledRed':
      return `solid 1px ${colorPalette.status_error_light}`;
    case 'unfilledGrey':
      return `solid 1px ${colorPalette.blue_400}`;
    case 'unfilledOrange':
      return `solid 1px ${colorPalette.secondary_600}`;
    case 'filledBlue':
      return `solid 1px ${colorPalette.blue_500}`;
    case 'unfilledGreyWithoutBorder':
      return 'none';
    case 'unfilledRed':
      return `solid 1px ${colorPalette.status_error}`;
    case 'unfilledBlue':
      return `solid 1px ${colorPalette.blue_500}`;
  }
};
export const getHoverBackground = ($displayStyle?: ButtonDisplayStyle) => {
  if (!$displayStyle) return 'transparent';
  switch ($displayStyle) {
    case 'filledOrange':
      return colorPalette.secondary_300;
    case 'primary':
      return colorPalette.white;
    case 'filledRed':
      return colorPalette.status_error_light;
    case 'unfilledGrey':
      return colorPalette.blue_400;
    case 'unfilledOrange':
      return colorPalette.secondary_600;
    case 'filledBlue':
      return colorPalette.blue_500;
    case 'unfilledGreyWithoutBorder':
      return 'unset';
    case 'unfilledRed':
      return colorPalette.status_error;
    case 'unfilledBlue':
      return colorPalette.blue_500;
    case 'filledAccent':
      return colorPalette.light_yellow;
    case 'text':
      return colorPalette.secondary_100;
    case 'underlineText':
      return 'transparent';
  }
};

export const getHoverColor = ($displayStyle?: ButtonDisplayStyle) => {
  if (!$displayStyle) return colorPalette.grey_400;
  switch ($displayStyle) {
    case 'primary':
      return colorPalette.primary;
    case 'unfilledGreyWithoutBorder':
      return colorPalette.grey_400;
    case 'filledAccent':
      return colorPalette.eerie_black;
    case 'underlineText':
    case 'text':
      return colorPalette.secondary_600;
  }
};
export const getDisabledBorder = ($displayStyle?: ButtonDisplayStyle) => {
  if (!$displayStyle) return 'none';
  switch ($displayStyle) {
    case 'filledOrange':
    case 'filledRed':
    case 'filledBlue':
    case 'filledAccent':
      return `solid 1px ${colorPalette.grey_400}`;
    case 'unfilledGrey':
    case 'unfilledOrange':
    case 'unfilledRed':
    case 'unfilledBlue':
      return `solid 1px ${colorPalette.grey_600}`;
    default:
      return 'none';
  }
};
export const getDisabledBackground = ($displayStyle?: ButtonDisplayStyle) => {
  if (!$displayStyle) return 'unset';
  switch ($displayStyle) {
    case 'filledOrange':
    case 'filledRed':
    case 'filledBlue':
    case 'filledAccent':
      return colorPalette.grey_400;
    case 'unfilledGrey':
    case 'unfilledOrange':
    case 'unfilledRed':
    case 'unfilledBlue':
      return colorPalette.white;
    default:
      return 'unset';
  }
};
export const getStartIconColor = ($displayStyle?: ButtonDisplayStyle) => {
  if (!$displayStyle) return colorPalette.greyMain;
  switch ($displayStyle) {
    case 'filledOrange':
    case 'filledRed':
    case 'filledBlue':
    case 'primary':
      return colorPalette.white;
    case 'unfilledGrey':
    case 'unfilledGreyWithoutBorder':
      return colorPalette.greyMain;
    case 'unfilledOrange':
      return colorPalette.secondary_600;
    case 'unfilledRed':
      return colorPalette.status_error;
    case 'unfilledBlue':
      return colorPalette.blue_500;
    case 'text':
      return colorPalette.secondary_600;
  }
};
